import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { GlgPopup, GlgPopupForm, GlgLoadingSpinner, GlgFormInput, GlgCheckbox } from 'SharedComponents'
import { FormControl } from 'react-bootstrap'
import CKEditor from 'ckeditor4-react'
import { fontNamesList, toolbar } from '../../helpers'
import Loader from 'react-loader-spinner'
import { Scrollbar } from 'react-scrollbars-custom'
import ReCAPTCHA from "react-google-recaptcha"

const APP_RECAPTCHA_V2_API_SITE_KEY = process.env.APP_RECAPTCHA_V2_API_SITE_KEY || "6Le-aKYpAAAAAM26PsRb_Ze17DrLwuP9KNWlFSxU"
export class RegisterMemberPopup extends Component {
  constructor(props) {
    super(props)
    this.onSave = this.onSave.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  onSave() {
    const token = this.props.registerMemberValues.recaptcha_token
    if (!token) {
      const msg = window.I18n
        ? window.I18n.t('recaptcha.invalid', {
            defaultValue: 'Failed to verify captcha.',
          })
        : 'Failed to verify captcha.'
      window.show_flash(msg)
      window.hide_flash()
      return
    }
    this.props.registerMember(this.props.member.id)
    window.onbeforeunload = null
  }

  onClose(){
    this.props.closeRegisterMemberPopup()
    window.onbeforeunload = null
  }
  
  render() {
    const popUpTitle = (
      <div className='title' key="popup_title">
        { !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.register_member', {name: this.props.member.fullName}) }
      </div>
    )
    const continueButtonText = this.props.isRegisterMemberLoading ? (!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.registering') ) : (!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.register') )
    const emailDescription = (
      <span>
        { !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.email_incorrect') }
        <span>
          <a href="#" className="can_open" onClick={() => this.props.openEditMemberModal(this.props.member.id)}>
            here
            <span className='glg-loading-spinner' style={{marginLeft: this.props.isOpenEditMemberModalLoading[this.props.member.id] ? '5px' : '0'}}>
              {this.props.isOpenEditMemberModalLoading[this.props.member.id] && (
                <Loader type="ThreeDots" color={ '#0088CE' } height={ 15 } width={ 30 } />
              )}
            </span>
          </a>
        </span>
        { ` ${!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.change_email')}` }
      </span>
    )
      
    const showAlert = !this.props.data.userFound && !this.props.data.usesGolfIdIntegration

    const password = this.props.registerMemberValues.temporary_password
    const containsLowercaseAndDigits = /^(?=.*[a-z])(?=.*\d).{8,}$/.test(password)
    const checkPass = showAlert === true ? !containsLowercaseAndDigits : false
    const disableRegisterButton = checkPass || !this.props.data.validEmail
    const showTemporaryPasswordError = checkPass && !this.props.isLoading
    const temporaryPasswordErrorId = `new_member_${this.props.member.id}_temporary_password_error`

    const alert = (
      <div className='alert alert-warning alert-dismissible product_warning modal_warning' style={{marginBottom: 0, width: '100%'}}>
        { showAlert && (
          <span>
            { !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.temporary_pass') }
            <span>
              <a href={this.props.newUserSessionUrl}>
                { this.props.newUserSessionUrl }
              </a>
            </span>
            { ` ${!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.sign_in')} ` }
          </span>
        )}
        {!this.props.isGcatCustomer && (
          <span>
            { `${!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.email_info', window.participantFormats)} ` }
            <span>
              <a href={showAlert ? this.props.editEmailTemplateRegisterMemberWithPasswordUrl : this.props.editEmailTemplateRegisterMemberWithoutPasswordUrl} target="_blank">
                { `${!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.here')}.` }
              </a>
            </span>
          </span>
        )}
      </div>
    )
    const recaptchaFooterContent = (
      <React.Fragment>
        <div className="recaptcha-v2-wrapper pull-left">
          <ReCAPTCHA
            sitekey={APP_RECAPTCHA_V2_API_SITE_KEY}
            onChange={(token) => this.props.updateRegistration('recaptcha_token', token)}
            onExpired={() => this.props.updateRegistration('recaptcha_token', null)}
            onErrored={() => this.props.updateRegistration('recaptcha_token', null)}
          />
        </div>
        <div className="visible-xs recaptcha-mobile-spacer" />
      </React.Fragment>
    )

    return (
      <GlgPopup
        title={() => popUpTitle}
        modalClass="modal-lg re_register_player_roster btsp_ps_container btsp_modal_content"
        show={ this.props.show }
        onClose={ this.onClose }
        manualClose={ true }
        showCloseButton={ false }
        showSaveButton={ false }
        footerContent={recaptchaFooterContent}
        customButtons={[
          { class: 'gdpr_btn btsp_orange_button save_button pull-right btn ' + (this.props.isRegisterMemberLoading || disableRegisterButton ? 'disabled' : ''), text: continueButtonText, onClick: this.onSave, disabled: disableRegisterButton},
          { class: 'cancel_roster btn button btsp_gray_button pull-right', text: !window.I18n ? '' : window.I18n.t('buttons.cancel').charAt(0)
            .toUpperCase() + (!window.I18n ? '' : window.I18n.t('buttons.cancel').slice(1)), onClick: this.onClose },
        ]}
      >
        <Scrollbar
          wrapperProps={{
            renderer: props => {
              const { elementRef, ...restProps } = props
              return <div {...restProps} ref={elementRef} style={{...restProps.style, position: 'relative', maxHeight: '50vh'}} />
            },
          }}
          scrollerProps={{
            renderer: props => {
              const { elementRef, ...restProps } = props
              return <div {...restProps} ref={elementRef} style={{...restProps.style, position: 'relative', maxHeight: '50vh'}} />
            },
          }}
          trackYProps={{
            renderer: props => {
              const { elementRef, ...restProps } = props
              return <span {...restProps} ref={elementRef} style={{...restProps.style, height: 'calc(100%)'}} />
            },
          }}
          disableTracksWidthCompensation={true}
        >
          <GlgPopupForm leftSideColumnsCount={3} alert={alert} showAlert={!this.props.isGcatCustomer}>
            <GlgLoadingSpinner
              show={ this.props.isLoading }
              height={ 50 }
              width={ 50 }
              className="loading-spinner" />
            <GlgFormInput
              name={`new_member_${this.props.member.id}_email`}
              label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.email') }
              description={{title: emailDescription}}
            >
              <FormControl
                name={`new_member_${this.props.member.id}_first_name_input`}
                value={ this.props.registerMemberValues.email }
                readOnly={true} />
            </GlgFormInput>
            <GlgFormInput
              name={`new_member_${this.props.member.id}_first_name`}
              label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.first_name') }
            >
              <FormControl
                name={`new_member_${this.props.member.id}_first_name_input`}
                value={this.props.registerMemberValues.first_name}
                onChange={(e) => this.props.updateRegistration('first_name', e.target.value)} />
            </GlgFormInput>
            <GlgFormInput
              name={`new_member_${this.props.member.id}_last_name`}
              label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.last_name') }
            >
              <FormControl
                name={`new_member_${this.props.member.id}_last_name_input`}
                value={this.props.registerMemberValues.last_name}
                onChange={(e) => this.props.updateRegistration('last_name', e.target.value)} />
            </GlgFormInput>
            { !this.props.data.userFound && !this.props.data.usesGolfIdIntegration && (
              <GlgFormInput
                name={`new_member_${this.props.member.id}_temporary_password`}
                label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.password') }
                description={{title: !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.change_temp_pass', window.participantFormats)}}
                withoutBorder={true}
              >
                <FormControl
                  name={`new_member_${this.props.member.id}_temporary_password_input`}
                  value={this.props.registerMemberValues.temporary_password}
                  aria-invalid={showTemporaryPasswordError}
                  aria-describedby={showTemporaryPasswordError ? temporaryPasswordErrorId : null}
                  onChange={(e) => this.props.updateRegistration('temporary_password', e.target.value)} />
                { showTemporaryPasswordError && (
                  <div id={temporaryPasswordErrorId} role="alert" className='error-message btsp_alert_notices add-margin-top-5'>
                    { !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.invalid_temp_pass') }
                  </div>
                )}
              </GlgFormInput>
            )}
            { !this.props.data.userFound && !this.props.data.usesGolfIdIntegration && (
              <GlgFormInput
                name={`new_member_${this.props.member.id}_permanent_password`}
                label={''}
                description={{title: (!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.permanent_password_title')), text: (!window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.permanent_password_info', window.participantFormats))}}
              >
                <GlgCheckbox
                  name={`new_member_${this.props.member.id}_permanent_password_checkbox`}
                  onChange={(val) => this.props.updateRegistration('permanent_password', val)}
                  defaultChecked={this.props.registerMemberValues.permanent_password}
                  label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.permanent_password') } />
              </GlgFormInput>
            )}
            { this.props.member.old_user_id && (
              <GlgFormInput
                name={`new_member_${this.props.member.id}_propagate_user`}
                label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.event_registration') }
              >
                <GlgCheckbox
                  name={`new_member_${this.props.member.id}_permanent_password_checkbox`}
                  onChange={(val) => this.props.updateRegistration('propagate_user', val)}
                  defaultChecked={this.props.registerMemberValues.propagate_user}
                  label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.golfer_linked_to_user', window.participantFormats) } />
              </GlgFormInput>
            )}
            <GlgFormInput
              name={`new_member_${this.props.member.id}_propagate_user`}
              label={ !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.message') }
              description={{title: !window.I18n ? '' : window.I18n.t('members_page.components.register_member.register_member_popup.message_info', window.participantFormats)}}
            >
              <CKEditor
                id="register_member_textarea"
                name={`new_member_${this.props.member.id}_permanent_password_checkbox`}
                onChange={(val) => this.props.updateRegistration('email_message', val.editor.getData())}
                onInstanceReady={ e => {
                  window.glg.translation.ckeditorHtmlLang(e.editor)
                } }
                value={this.props.registerMemberValues.emailMessage}
                config={{
                  toolbar: toolbar,
                  contentsCss: this.props.ckeditorPath,
                  filebrowserUploadUrl: '/ckeditor/pictures',
                  removeDialogTabs: 'image:advanced;image:Link;link:Advanced;link:upload;',
                  line_height: '1;1.2;1.4;1.6;1.8;2;2.2;2.4;2.6;2.8;3;',
                  font_names: fontNamesList,
                }} />
            </GlgFormInput>
          </GlgPopupForm>
        </Scrollbar>
      </GlgPopup>
    )
  }
}

RegisterMemberPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  closeRegisterMemberPopup: PropTypes.func.isRequired,
  registerMember: PropTypes.func.isRequired,
  updateRegistration: PropTypes.func.isRequired,
  registerMemberValues: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  isRegisterMemberLoading: PropTypes.bool.isRequired,
  isGcatCustomer: PropTypes.bool.isRequired,
  member: PropTypes.object.isRequired,
  ckeditorPath: PropTypes.string.isRequired,
  openEditMemberModal: PropTypes.func.isRequired,
  isOpenEditMemberModalLoading: PropTypes.object.isRequired,
  newUserSessionUrl: PropTypes.string,
  editEmailTemplateRegisterMemberWithPasswordUrl: PropTypes.string,
  editEmailTemplateRegisterMemberWithoutPasswordUrl: PropTypes.string,
  elementRef: PropTypes.any,
}

RegisterMemberPopup.defaultProps = {
  data: {
    userFound: true,
  },
}

export default RegisterMemberPopup
